import { List, Alert, ListItem, Typography, ListItemText } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type SecurityWarningAlertProps = {
  title: string;
  warnings: string[];
};

export function SecurityWarningAlert({ title, warnings }: SecurityWarningAlertProps) {
  return (
    <Alert severity="warning" variant="outlined" sx={{ mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <List dense sx={{ p: 0 }}>
        {warnings.map((warning, index) => (
          <ListItem key={index} sx={{ alignItems: 'flex-start', px: 0, py: 0.5 }}>
            <Iconify
              icon="material-symbols:warning"
              sx={{ color: 'warning.main', mr: 1, mt: 0.25, flexShrink: 0 }}
              width={16}
            />
            <ListItemText primary={warning} primaryTypographyProps={{ variant: 'body2' }} />
          </ListItem>
        ))}
      </List>
    </Alert>
  );
}
